import React from 'react'
import { useDispatch } from 'react-redux'
import { Button, Toast } from 'antd-mobile-v5'
import { Modal, WingBlank } from 'antd-mobile'
import { FormattedMessage, useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { owsiCdApproved } from '../../services/api'
import { getSubmitOssFormat, showAlert, showModal } from '../../components/common/utils'
import PaymentBtn from '../../components/FormTools/PaymentBtn'
import { usePayOwsi, useProfile } from '../../services/hooks'
import StepStatus from '../../components/FormTools/StepStatus'
import { pageLoaded, pageLoading } from '../../actions'

import styles from '../DiveMasterForm/DiveMasterForm.module.css'

const moduleMapping = {
  module1: 'Written Exam (Pass)',
  module2: 'Knowledge Development (Pass)',
  module3: 'Confined Water (Pass)',
  module4: 'Open Water (Pass)',
}

const Status = ({ form, getSubmitData, cdDetail, agreement, signature }) => {
  const { status, note, paymentMethod, paymentType, payerType, code, module1, module2, module3, module4 } = cdDetail
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const { replace, push } = useHistory()
  const { runAsync: toPay } = usePayOwsi()
  const { data: profile } = useProfile()
  const editableStatus = status === 'ADMIN_NOT_APPROVED' || status === 'WAIT_CONFIRM'

  const approvedAction = async (approve) => {
    await form.validateFields()
    if (!signature) {
      Toast.show({
        content: formatMessage({ id: 'dm-form-signature-confirm' }),
      })
      return
    }
    if (!agreement) {
      Toast.show({
        content: formatMessage({ id: 'common-check-agreement' }),
      })
      return
    }
    if (approve) {
      if (!cdDetail.payerType) {
        Modal.alert('', formatMessage({ id: 'owsi-pay-tips' }), [
          { text: formatMessage({ id: 'owsi-candidate-pay' }), onPress: () => submitApprovedFn('CANDIDATE') },
          { text: formatMessage({ id: 'owsi-cd-pay' }), onPress: () => submitApprovedFn('CD') },
          { text: formatMessage({ id: 'common-cancel' }), onPress: () => console.log('cancel') },
        ])
      } else {
        submitApprovedFn()
      }
    } else {
      Modal.prompt(formatMessage({ id: 'dm-refuse-reason' }), formatMessage({ id: 'dm-refuse-tips' }), [
        { text: formatMessage({ id: 'common-cancel' }) },
        {
          text: formatMessage({ id: 'common-comfirmBtn' }),
          onPress: async (value) => {
            if (!value) {
              showModal(
                '',
                formatMessage({ id: 'dm-refuse-error' }),
                () => {},
                () => {},
                formatMessage({ id: 'common-comfirmBtn' }),
                formatMessage({ id: 'common-cancel' })
              )
              return
            }
            const { idcdate, idcendDate } = getSubmitData()
            const approvedData = {
              approve,
              code: cdDetail.code,
              handwrittenSignatureUrl: getSubmitOssFormat(signature),
              note: value,
              idcdate,
              idcendDate,
            }
            try {
              dispatch(pageLoading())
              const response = await owsiCdApproved(approvedData)
              if (response.error) {
                showAlert(response.error.clientMsg, formatMessage({ id: 'common-close' }))
              } else {
                replace('/owsi_cd_apps')
              }
            } catch (e) {
              showAlert(formatMessage({ id: 'common-errorStatus' }), formatMessage({ id: 'common-close' }))
            } finally {
              dispatch(pageLoaded())
            }
          },
        },
      ])
    }
  }

  const toPayIe = async (code) => {
    const result = await toPay(code)
    if (result.error) {
      showAlert(result.error.clientMsg, formatMessage({ id: 'common-close' }))
      return
    }
    if (result.url) {
      if (profile.teachingLocation === 'TW')
        return push('/invoice_form', {
          code,
          nextUrl: result.url,
          type: 'MEMBER_APPLICATION_OWSI',
        })
      window.location.replace(result.url)
    }
  }

  const submitApprovedFn = (payerType) => {
    showModal(
      '',
      formatMessage({ id: 'dm-form-instructor-accept-confirm' }),
      async () => {
        let approvedData = {
          approve: true,
          code: cdDetail.code,
          handwrittenSignatureUrl: getSubmitOssFormat(signature),
        }
        if (editableStatus) {
          const formData = getSubmitData()
          approvedData = {
            ...formData,
            ...approvedData,
          }
        }
        if (payerType) approvedData.payerType = payerType
        try {
          dispatch(pageLoading())
          const response = await owsiCdApproved(approvedData)
          if (response.error) {
            showAlert(response.error.clientMsg, formatMessage({ id: 'common-close' }))
          } else {
            if (payerType === 'CD') await toPayIe(cdDetail.code)
            else replace('/owsi_cd_apps')
          }
        } catch (e) {
          showAlert(formatMessage({ id: 'common-errorStatus' }), formatMessage({ id: 'common-close' }))
        } finally {
          dispatch(pageLoaded())
        }
      },
      () => {},
      formatMessage({ id: 'common-comfirmBtn' }),
      formatMessage({ id: 'common-cancel' })
    )
  }

  switch (status) {
    case 'WAIT_CONFIRM':
      return (
        <div className={styles.btns}>
          <Button inline color="primary" className={styles.btn} onClick={() => approvedAction(true)}>
            <FormattedMessage id="dm-form-agree" />
          </Button>
          <Button inline color="warning" className={styles.btn} onClick={() => approvedAction(false)}>
            <FormattedMessage id="dm-form-reject" />
          </Button>
        </div>
      )
    case 'INSTRUCTOR_APPROVED':
      if (paymentMethod) {
        return <StepStatus desc={formatMessage({ id: 'app-wait-cs-review' })} />
      }
      if (paymentType) {
        if (payerType === 'CD') {
          return (
            <WingBlank>
              <PaymentBtn code={code} paymentFn={toPay} payApplicationType={'MEMBER_APPLICATION_OWSI'} />
            </WingBlank>
          )
        } else if (payerType === 'CANDIDATE') {
          return <StepStatus desc={formatMessage({ id: 'app-wait-candidate-pay' })} />
        }
      }
      return null
    case 'INSTRUCTOR_NOT_APPROVED':
      return <StepStatus desc={formatMessage({ id: 'app-status-instructor-not-approved' })} />
    case 'ADMIN_NOT_APPROVED':
      return (
        <>
          <div className={styles.btns}>
            <Button inline color="primary" className={styles.btn} onClick={() => approvedAction(true)}>
              <FormattedMessage id="dm-form-agree" />
            </Button>
            <Button inline color="warning" className={styles.btn} onClick={() => approvedAction(false)}>
              <FormattedMessage id="dm-form-reject" />
            </Button>
          </div>
          <StepStatus desc={formatMessage({ id: 'app-cs-not-approved' })} note={note} />
        </>
      )
    case 'NOT_PASS':
      return (
        <>
          <StepStatus desc={formatMessage({ id: 'owsi-not-pass' })} />
          <div>
            <FormattedMessage id="owsi-not-pass-reason" />
            {module1 && <div>{moduleMapping.module1}</div>}
            {module2 && <div>{moduleMapping.module2}</div>}
            {module3 && <div>{moduleMapping.module3}</div>}
            {module4 && <div>{moduleMapping.module4}</div>}
          </div>
        </>
      )
    case 'PASS':
      return <StepStatus desc={formatMessage({ id: 'app-wait-cert' })} />
    case 'SUCCESS':
      return <StepStatus desc={formatMessage({ id: 'app-success' })} />
    case 'CLOSE':
      return <StepStatus desc={formatMessage({ id: 'app-close' })} />
    default:
      return null
  }
}

export default Status
